/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['articles-order-select{display:inline-block;width:100%}articles-order-select>.input-container{max-width:100%}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvaGVscC1jZW50ZXIvc2hhcmVkL2FydGljbGVzLW9yZGVyLXNlbGVjdC9hcnRpY2xlcy1vcmRlci1zZWxlY3QuY29tcG9uZW50LnNjc3MubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvaGVscC1jZW50ZXIvc2hhcmVkL2FydGljbGVzLW9yZGVyLXNlbGVjdC9hcnRpY2xlcy1vcmRlci1zZWxlY3QuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/help-center/shared/articles-order-select/articles-order-select.component.scss.ngstyle.ts